// Тумблер: включено/выключено одним касанием.
//
// Заведён для карточек правил автоматизации (правка владельца 08.08.2026:
// «на карточки должен быть тумблер, переключающий их»). Текстовая ссылка
// «выключить» там была не видна: владелец её не нашёл и решил, что единственный
// способ управлять правилами — общий рубильник школы.
//
// Родной `input type=checkbox` под ним — не декорация: с ним работают
// клавиатура, скринридер и тесты (getByRole('switch')).
import { cn } from '@/lib/utils';

export function ToggleSwitch({
  checked,
  onChange,
  label,
  disabled = false,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Подпись для скринридера и тестов; рядом с тумблером не рисуется. */
  label: string;
  disabled?: boolean;
}): JSX.Element {
  return (
    <label className={cn('inline-flex items-center', disabled && 'opacity-50')}>
      <input
        type="checkbox"
        role="switch"
        aria-label={label}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="peer sr-only"
      />
      <span
        aria-hidden="true"
        className={cn(
          'relative h-5 w-9 shrink-0 cursor-pointer rounded-full transition-colors',
          'peer-focus-visible:ring-2 peer-focus-visible:ring-primary peer-focus-visible:ring-offset-1',
          checked ? 'bg-primary' : 'bg-divider-gray',
          disabled && 'cursor-default',
        )}
      >
        <span
          className={cn(
            'absolute top-0.5 h-4 w-4 rounded-full bg-canvas-white shadow transition-all',
            checked ? 'left-[1.125rem]' : 'left-0.5',
          )}
        />
      </span>
    </label>
  );
}
